import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getCreditLimits = (params) => {
    return axios.get(`${backendHost}/api/admin/limits`, {params});
};

export {
    getCreditLimits
}